import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import VideoPlayer from "./components/VideoPlayer";
import Sidebar from "./components/Sidebar";
import Notifications from "./components/Notifications";

const SECRET = "ca93F3v3G2UsQG3Q1nGm";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100vh",
    background: "#202124",
  },
  header: {
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    background: "#202124",
    borderBottom: "1px solid #3c4043",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    color: "#e8eaed",
    fontSize: "20px",
    fontWeight: 600,
  },
  logoIcon: {
    width: "34px",
    height: "34px",
    background: "#1a73e8",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "18px",
    fontWeight: 700,
  },
  mainContent: {
    display: "flex",
    flex: 1,
    width: "100%",
    overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
      overflow: "visible",
    },
  },
  noTokenWrap: {
    minHeight: "calc(100vh - 60px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px",
  },
  noTokenMsg: {
    maxWidth: "760px",
    textAlign: "center",
    color: "#e8eaed",
    fontSize: "22px",
    lineHeight: 1.5,
    [theme.breakpoints.down("sm")]: { fontSize: "18px" },
  },
}));

const App = () => {
  const classes = useStyles();
  const p = new URLSearchParams(window.location.search);
  const token = p.get("token") || "";
  const secret = p.get("secret") || "";
  const valid = Boolean(token && secret === SECRET);

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.logo}>
          <div className={classes.logoIcon}>T</div>
          <span>Täby Rehab Center</span>
        </div>
      </div>

      {!valid ? (
        <div className={classes.noTokenWrap}>
          <Typography className={classes.noTokenMsg}>
            Klicka på länken från https://rehab.se/boka eller som du fått via sms
          </Typography>
        </div>
      ) : (
        <div className={classes.mainContent}>
          <VideoPlayer />
          <Sidebar>
            <Notifications />
          </Sidebar>
        </div>
      )}
    </div>
  );
};

export default App;
